const NAME = "CALENDAR_DEFINITION";

export default NAME;
